import { createAsyncThunk } from '@reduxjs/toolkit';

import { getVoltageListService } from 'services/voltage.service';

export const getVoltageList = createAsyncThunk(
  'voltage/list',
  async (_, thunkApi) => {
    try {
      const response = await getVoltageListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
